import {createApp} from "vue";
import AppRelationPosts from "./AppPosts.vue";
import AppListFilterAndSort from "./AppListFilterAndSort.vue";

document.addEventListener("DOMContentLoaded", () => {
  const postFilter = document.getElementById('js-post-filter');
  if (postFilter) {
    const app = createApp(AppListFilterAndSort);
    app.mount(postFilter);
  }

  const relationPostsArea = document.getElementById('js-posts');
  if (relationPostsArea) {
    const app = createApp(AppRelationPosts);
    app.provide('ids', relationPostsArea.dataset.ids);
    app.provide('userId', Number(relationPostsArea.dataset.userId));
    app.mount(relationPostsArea);
  }
});
